export default "/biometrie-afghanistan/media/af0ade18e6a09b02bd32de652264a0c9~matthias-laptop.jpg";